export const APP_NAME = 'customerVehicles';
export const MAX_TRADE_INS_FOR_MODAL = 3;
